import { forwardRef } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import {
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from '@mui/material';
import { RadioButton } from './RadioButton.component';

const StyledFormLabel = styled(FormLabel)`
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  &.Mui-focused {
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

const radioLabelStyle = (theme) => css`
  margin-right: ${theme.spacing(6)};
  color: ${theme.palette.text.primary};
  & .MuiRadio-root {
    padding: ${theme.spacing(1)} 9px;
  }
`;

export const RadioButtonsGroup = forwardRef(({
  radioChoices = [],
  formLabel = '',
  row = false,
  defaultValue = '',
  handleChange = () => {},
  groupName = '',
  value = '',
  ...restProps
}, forwardedRef) => (
  <FormControl component="fieldset" {...restProps}>
    {formLabel && <StyledFormLabel component="legend">{formLabel}</StyledFormLabel>}
    <RadioGroup
      row={row}
      aria-label={groupName}
      name={groupName}
      defaultValue={defaultValue}
      onChange={handleChange}
      value={value}
    >
      {
        radioChoices.map((item) => (
          <div key={item.value}>
            <FormControlLabel
              css={radioLabelStyle}
              key={item.value}
              value={item.value}
              control={<RadioButton ref={forwardedRef} />}
              label={item.label}
            />
            {item.description}
          </div>
        ))
      }
    </RadioGroup>
  </FormControl>
));

RadioButtonsGroup.propTypes = {
  radioChoices: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      description: PropTypes.node,
    }),
  ),
  formLabel: PropTypes.string,
  row: PropTypes.bool,
  defaultValue: PropTypes.string,
  handleChange: PropTypes.func,
  groupName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
